import { syntheticEvent } from '../../../utils/SyntheticEvent';
import { Flex } from '../../../../components/Flex/Flex';
import { View } from '../../../../components/View/View';
import { ScrollContainer } from '../../ScrollContainer/ScrollContainer';
import { Popover } from '../../Popover';
import { lazyEval } from '../../../utils/lazyEval';
import { CalendarFooterButton } from './CalendarFooterButton';
import { CalendarPageWithRange } from './CalendarPageWithRange';
import styled from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledPresetBox = styled.button.withConfig({
  displayName: "DateRangePopover__StyledPresetBox",
  componentId: "i0hkb7-0"
})(({
  selected,
  theme
}) => {
  return Object.assign({
    all: 'unset',
    cursor: 'pointer',
    width: '100%',
    margin: theme.space['0'],
    paddingBlock: theme.space['200'],
    paddingInline: theme.space['500'],
    '&:hover': {
      backgroundColor: theme.color['fill-secondary-subtle']
    }
  }, selected && {
    backgroundColor: theme.color['fill-secondary-subtle']
  });
});
export const DateRangePopover = ({
  calendarId,
  children,
  clearLabel = 'Clear',
  today,
  onCalendarPageChange,
  onActiveBoundChange,
  onChange,
  onFocusLeave,
  onOpenChange,
  open,
  presets,
  showPresets,
  tz,
  value,
  min,
  max,
  minValidationMessage = '',
  maxValidationMessage = '',
  calendarPage,
  activeBound
}) => {
  return /*#__PURE__*/_jsx(Popover, {
    arrowSize: "none",
    content: /*#__PURE__*/_jsxs(Flex, {
      blockSize: "342px",
      children: [showPresets && /*#__PURE__*/_jsx(ScrollContainer, {
        scrollDirection: "vertical",
        maxWidth: 200,
        maxHeight: '100%',
        children: presets.map(preset => {
          const {
            presetId
          } = preset;
          return /*#__PURE__*/_jsx(StyledPresetBox, {
            onMouseDown: e => e.preventDefault(),
            onClick: () => {
              onChange(syntheticEvent(Object.assign({}, preset.getValue(tz), {
                presetId
              })));
            },
            selected: value.presetId === presetId,
            "data-preset-id": presetId,
            children: preset.getText()
          }, presetId);
        })
      }), /*#__PURE__*/_jsxs(View, {
        paddingBlockStart: "500",
        paddingBlockEnd: "600",
        paddingInline: "200",
        borderInlineStartWidth: "100",
        borderInlineStartStyle: "solid",
        borderInlineStartColor: "border-core-default",
        children: [/*#__PURE__*/_jsx(CalendarPageWithRange, {
          calendarPage: calendarPage,
          max: max,
          maxValidationMessage: maxValidationMessage,
          min: min,
          minValidationMessage: minValidationMessage,
          onCalendarPageChange: onCalendarPageChange,
          today: today,
          id: calendarId,
          onChange: onChange,
          value: value,
          onActiveBoundChange: onActiveBoundChange,
          activeBound: activeBound
        }), /*#__PURE__*/_jsx(Flex, {
          justifyContent: "space-between",
          marginBlockStart: "400",
          marginInline: "300",
          children: /*#__PURE__*/_jsx(CalendarFooterButton, {
            block: true,
            "data-action": "clear",
            onClick: () => {
              onChange(syntheticEvent({
                startDate: undefined,
                endDate: undefined
              }));
              onActiveBoundChange(syntheticEvent(null));
            },
            children: lazyEval(clearLabel)
          })
        })]
      })]
    }),
    onOpenChange: onOpenChange,
    placement: "bottom right",
    onFocusLeave: onFocusLeave,
    open: open,
    children: children
  });
};